<template>
  <v-card>
    <v-card-title class="headline">
      <span class="grow">
        {{ $t('sorting') }}
      </span>
      <div :style="{ height: 0, display: 'flex', alignItems: 'center' }">
        <v-btn icon left @click="$emit('close')">
          <v-icon>close</v-icon>
        </v-btn>
      </div>
    </v-card-title>
    <v-card-text>
      <form :id="id('form')" novalidate @submit.prevent="handleSubmit">
        <div>
          <label :for="id('by')">{{ $t('sort_by') }}</label>
          <v-select
            :id="id('by')"
            v-model="form.by"
            :items="sortByOptions"
            outline
            single-line
            hide-details
          />
        </div>
        <div>
          <label :for="id('order')">{{ $t('sort_order') }}</label>
          <v-select
            :id="id('order')"
            v-model="form.order"
            :items="orderByOptions"
            outline
            single-line
            hide-details
          />
        </div>
      </form>
    </v-card-text>
    <v-card-actions class="justify-center">
      <v-btn outline color="grey" @click="handleReset">{{ $t('reset') }}</v-btn>
      <v-btn depressed color="primary" type="submit" :form="id('form')">{{ $t('Search') }}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      default: undefined
    }
  },
  data() {
    return {
      form: this.value
        ? { ...this.value }
        : {
            by: 'intentname',
            order: 'asc'
          }
    }
  },
  computed: {
    sortByOptions() {
      return [
        {
          value: 'intentname',
          text: this.$t('conversation_name')
        },
        {
          value: 'id',
          text: this.$t('created_date')
        },
        {
          value: 'updated_at',
          text: this.$t('updated_date')
        }
      ]
    },
    orderByOptions() {
      const ascText = {
        intentname: this.$t('from_a_to_z'),
        id: this.$t('oldest_created_date'),
        updated_at: this.$t('oldest_updated_date')
      }[this.form.by]

      const descText = {
        intentname: this.$t('from_z_to_a'),
        id: this.$t('newest_created_date'),
        updated_at: this.$t('newest_updated_date')
      }[this.form.by]

      return [
        {
          value: 'asc',
          text: ascText
        },
        {
          value: 'desc',
          text: descText
        }
      ]
    }
  },
  methods: {
    id(field) {
      return `${field}-${this._uid}`
    },
    handleReset() {
      this.$emit('submit', {
        by: 'intentname',
        order: 'asc'
      })
    },
    handleSubmit() {
      this.$emit('submit', this.form)
    }
  }
}
</script>

<style lang="scss" scoped>
.v-card__text form > * + * {
  margin-top: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/view/intent/SortingFilterForm.vue